<div class="form-inline">
  <label *ngIf="objectId">
    <h6>
      <span *ngIf="prefix" class="text-default"> {{ prefix }} : </span>
      <span class="text-primary"> {{ objectName }} </span>
    </h6>

    <a (click)="clearObject()" class="text-danger link">
      <nb-icon icon="close-circle-outline"></nb-icon>
    </a>
  </label>

  <a *ngIf="!objectId" (click)="selectObject()" class="text-primary link">
    <nb-icon icon="menu-2-outline"></nb-icon>
    {{ title }}
  </a>
</div>
